var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"team-management-panel__statistics-item"},[_c('div',{staticClass:"team-management-panel__statistics-sign",class:[_vm.type]},[_c('span',{staticClass:"team-management-panel__statistics-sign--inner"})]),_c('span',[_vm._v(_vm._s(_vm.typeText)+"("+_vm._s(_vm.num)+")")])])
}
var staticRenderFns = []

export { render, staticRenderFns }